import React, { useMemo, useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';
//import CanonicalDataset from './CanonicalDataset';
import ClinicalTrialsGov from './ClinicalTrialsGov';
import WHORegistry from './WHORegistry';
import EuropeanUnionRegistry from './EuropeanUnionRegistry';
import GermanyTrialRegistry from './GermanyTrialRegistry';
import IndiaRegistry from './IndiaRegistry';
import JapanTrialRegistry from './JapanTrialRegistry';
import SouthKoreaRegistry from './SouthKoreaRegistry';
import AustraliaNewZealandRegistry from './AustraliaNewZealandRegistry';
import ScrollToTop from '../common/ScrollToTop';

const tabConfig = [
  //{ id: 'canonical-dataset', label: 'Core Dataset', component: CanonicalDataset },
  { id: 'clinical-trials-gov', label: 'Clinical_Trials.gov', component: ClinicalTrialsGov },
  { id: 'who', label: 'WHO', component: WHORegistry },
  { id: 'eu', label: 'European Union', component: EuropeanUnionRegistry },
  { id: 'germany', label: 'Germany Trial Registry', component: GermanyTrialRegistry },
  { id: 'india', label: 'India', component: IndiaRegistry },
  { id: 'japan', label: 'Japan Trial Registry', component: JapanTrialRegistry },
  { id: 'south-korea', label: 'South Korea', component: SouthKoreaRegistry },
  { id: 'anz', label: 'Australia & New Zealand', component: AustraliaNewZealandRegistry },
];

const ProtocolRegistration = ({ projectId }) => {
  //const [activeTab, setActiveTab] = useState(tabConfig[0].id);
    const [activeTab, setActiveTab] = useState(tabConfig[0]?.id || 'clinical-trials-gov');

  const ActiveComponent = useMemo(() => {
    const match = tabConfig.find((tab) => tab.id === activeTab);
    return match ? match.component : tabConfig[0].component;
  }, [activeTab]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 2 }} elevation={0}>
        <Typography variant="h5" gutterBottom>
          Protocol Registration
        </Typography>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 3 }}
        >
          {tabConfig.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.id} />
          ))}
        </Tabs>

        <ActiveComponent projectId={projectId} />
      </Paper>

      {/* Scroll to Top Button */}
      <ScrollToTop />
    </Box>
  );
};

export default ProtocolRegistration;

